module.exports = __webpack_public_path__ + "img/nt1-04-75-1_1.prt.78041949.jpg";